// Мок данные на основе структуры Excel файла с отчетом по зарплате
export const mockEmployees = [
  {
    id: 1,
    name: "Петренко Іван Васильович",
    login: "petrenko", // Добавляем логин
    position: "Електромеханік",
    grade: "5 розряд",
    salary: {
      baseSalary: 18000,
      bonus: 2500,
      allowances: 1200,
      fines: 500,
      travel: 800,
      totalIncome: 22000,
      netPay: 19800,
      old_allowance: 3500
    },
    workMetrics: {
      passengerElevators: 15,
      commercialElevators: 8,
      totalElevators: 23,
      applications: {
        total: 45,
        repeat: 8,
        stopped: 3,
        stuck: 2
      },
      maintenance: {
        notCompleted: 2,
        checked: 20,
        issuesNotFixed: 1,
        lateResponse: 1
      }
    },
    performance: {
      maintenanceCompletion: 92,
      responseTime: 85,
      qualityScore: 88
    },
    notes: [
      "Потребує додаткового навчання з новими моделями ліфтів",
      "Рекомендується підвищення розряду",
      "Хорошо працює з пасажирськими ліфтами",
      "ІНШІ ДОПЛАТИ: Надурочна робота - 1500 грн",
      "ІНШІ ДОПЛАТИ: Робота в святкові дні - 2000 грн"
    ]
  },
  {
    id: 2,
    name: "Коваленко Марія Олександрівна", 
    login: "kovalenko", // Добавляем логин
    position: "Електромеханік",
    grade: "4 розряд",
    salary: {
      baseSalary: 16000,
      bonus: 2000,
      allowances: 1000,
      fines: 0,
      travel: 600,
      totalIncome: 19600,
      netPay: 17640,
      old_allowance: 2500
    },
    workMetrics: {
      passengerElevators: 12,
      commercialElevators: 5,
      totalElevators: 17,
      applications: {
        total: 32,
        repeat: 4,
        stopped: 1,
        stuck: 1
      },
      maintenance: {
        notCompleted: 1,
        checked: 15,
        issuesNotFixed: 0,
        lateResponse: 0
      }
    },
    performance: {
      maintenanceCompletion: 95,
      responseTime: 92,
      qualityScore: 94
    },
    notes: [
      "Відмінна робота з комерційними ліфтами",
      "Рекомендується на премію за якість",
      "ІНШІ ДОПЛАТИ: Компенсація за телефон - 300 грн",
      "ІНШІ ДОПЛАТИ: Надурочна робота - 1200 грн"
    ]
  },
  {
    id: 3,
    name: "Сидоренко Олег Петрович",
    login: "sidorenko", // Добавляем логин
    position: "Електромеханік",
    grade: "6 розряд", 
    salary: {
      baseSalary: 20000,
      bonus: 3000,
      allowances: 1500,
      fines: 800,
      travel: 1000,
      totalIncome: 24700,
      netPay: 22230,
      old_allowance: 4300
    },
    workMetrics: {
      passengerElevators: 18,
      commercialElevators: 12,
      totalElevators: 30,
      applications: {
        total: 58,
        repeat: 12,
        stopped: 5,
        stuck: 4
      },
      maintenance: {
        notCompleted: 3,
        checked: 25,
        issuesNotFixed: 2,
        lateResponse: 2
      }
    },
    performance: {
      maintenanceCompletion: 87,
      responseTime: 78,
      qualityScore: 82
    },
    notes: [
      "Потребує покращення в роботі з повторними заявками",
      "Рекомендується додаткове навчання",
      "ІНШІ ДОПЛАТИ: Робота в нічний час - 2500 грн",
      "ІНШІ ДОПЛАТИ: Командировка - 1800 грн"
    ]
  },
  {
    id: 4,
    name: "Мельник Тетяна Іванівна",
    login: "melnyk", // Добавляем логин
    position: "Електромеханік",
    grade: "3 розряд",
    salary: {
      baseSalary: 14000,
      bonus: 1500,
      allowances: 800,
      fines: 200,
      travel: 500,
      totalIncome: 16600,
      netPay: 14940,
      old_allowance: 1500
    },
    workMetrics: {
      passengerElevators: 8,
      commercialElevators: 3,
      totalElevators: 11,
      applications: {
        total: 24,
        repeat: 3,
        stopped: 1,
        stuck: 0
      },
      maintenance: {
        notCompleted: 1,
        checked: 10,
        issuesNotFixed: 0,
        lateResponse: 1
      }
    },
    performance: {
      maintenanceCompletion: 91,
      responseTime: 86,
      qualityScore: 89
    },
    notes: [
      "Молодий спеціаліст, показує хороші результати",
      "Потребує менторства від досвідчених колег",
      "ІНШІ ДОПЛАТИ: Надурочна робота - 1000 грн",
      "ІНШІ ДОПЛАТИ: Компенсація за транспорт - 500 грн"
    ]
  },
  {
    id: 5,
    name: "Шевченко Андрій Миколайович",
    login: "shevchenko", // Добавляем логин
    position: "Старший електромеханік",
    grade: "6 розряд",
    salary: {
      baseSalary: 22000,
      bonus: 3500,
      allowances: 2000,
      fines: 300,
      travel: 1200,
      totalIncome: 28400,
      netPay: 25560,
      old_allowance: 5500
    },
    workMetrics: {
      passengerElevators: 20,
      commercialElevators: 15,
      totalElevators: 35,
      applications: {
        total: 67,
        repeat: 10,
        stopped: 4,
        stuck: 3
      },
      maintenance: {
        notCompleted: 2,
        checked: 30,
        issuesNotFixed: 1,
        lateResponse: 1
      }
    },
    performance: {
      maintenanceCompletion: 94,
      responseTime: 88,
      qualityScore: 91
    },
    notes: [
      "Досвідчений спеціаліст, відмінна робота",
      "Може навчати молодих колег",
      "Рекомендується на керівну посаду",
      "ІНШІ ДОПЛАТИ: Приватні консультації - 3000 грн",
      "ІНШІ ДОПЛАТИ: Навчання нових співробітників - 1500 грн"
    ]
  }
];

export const summaryData = {
  totalEmployees: 5,
  totalElevators: 116,
  totalApplications: 226,
  averageSalary: 20116,
  totalPayroll: 100580
};